import { gql } from '@apollo/client';
import { DiscountInfo } from '../fragments';

export default gql`
  mutation destroyDiscount($input: DiscountDestroyInput!) {
    destroyDiscount(input: $input) {
      clientMutationId
      discount {
        ...DiscountInfo
      }
    }
  }
  ${DiscountInfo}
`;
